module.exports = __webpack_public_path__ + "static/media/TarjetaCredito.5d485383.svg";